import { SnackbarMessage, VariantType } from 'notistack';

import { enqueueSnackbar } from '@store/features/notifications/slice';
import store from '@store/store';

const handleToast = (variant: VariantType, message: SnackbarMessage): void => {
  store.dispatch(
    enqueueSnackbar({
      message,
      options: {
        key: new Date().getTime() + Math.random(),
        variant,
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'right',
        },
      },
    }),
  );
};

export default handleToast;
